// extracted by mini-css-extract-plugin
export default {"inputBox":"InputBox_inputBox__LEmyQ"};